import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { kitSlice } from '../../context/KitContext';
import { Kit } from '../../types/kit/kit';
import { useAppDispatch } from '../../ui/pages/store';
import { KitFragment } from '../../graphql/kit.graphql';

const kitSubscription = gql`
  subscription kitNotification($companyId: String!) {
    kitNotification(companyId: $companyId) {
      companyId
      entities {
        ...Kit
      }
      topic
      date
    }
  }
  ${KitFragment.kit}
`;

export class KitNotificationResponse extends forNotification<Kit>('kitNotification') {}

export default function KitNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: kitNotifaction } = useSubscription<KitNotificationResponse>(kitSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleKitNotification = (notification?: KitNotificationResponse) => {
    if (!notification?.kitNotification) return;
    const kitNotification = notification.kitNotification;

    switch (kitNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(kitSlice.actions.add(kitNotification.entities));
        break;
      case 'DELETE':
        dispatch(kitSlice.actions.delete(kitNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleKitNotification(kitNotifaction);
  }, [kitNotifaction]);

  return <></>;
}
